import { render, staticRenderFns } from "./KimChokChartOptions.vue?vue&type=template&id=ca00e322"
import script from "./KimChokChartOptions.vue?vue&type=script&lang=ts"
export * from "./KimChokChartOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports